import $ from "jquery";

$(function () {

	var mediaQuery = window.matchMedia("(max-width: 767px)");
	if (mediaQuery.matches) {
		$(".shop-container__left .widgettitle").click(function () {
			$(this).toggleClass("active");
			$(this).next().toggleClass("active");
		});
	}
});
